import { render, staticRenderFns } from "./FilterSummaryOptionTigerC.vue?vue&type=template&id=2322d254&"
import script from "./FilterSummaryOptionTigerC.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionTigerC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports